export var DEFAULT_SKIN = 'light';
export var SKIN_COLOR = {
  light: 'D40-20',
  dark: 'D80-20'
};